// extracted by mini-css-extract-plugin
module.exports = {"flexColumn":"Sums_flexColumn__Jt0W9","alignItemsCenter":"Sums_alignItemsCenter__EYgFM","dimentions":"Sums_dimentions__y4SLH"};